var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRcIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    width: 23,
    height: 23,
    fill: "#414042"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "RcIcon",
    transform: "translate(0 -0.176)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71",
    "data-name": "Group 71",
    transform: "translate(0 0.176)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    "data-name": "Path 117",
    d: "M15.9,8.7c-.8,0-.99-.452-.41-1.029l2.232-2.222A8.746,8.746,0,0,0,2.885,10.487,1.367,1.367,0,0,1,1.455,11.6,1.453,1.453,0,0,1,0,10.147a1.535,1.535,0,0,1,.036-.319A11.664,11.664,0,0,1,19.782,3.4l2.387-2.377c.565-.562,1.023-.367,1.023.416V7.987a.722.722,0,0,1-.715.71Zm-8.61,5.8c.8,0,.99.452.41,1.029L5.469,17.747a8.749,8.749,0,0,0,14.842-5.042A1.367,1.367,0,0,1,21.74,11.6a1.453,1.453,0,0,1,1.452,1.45,1.524,1.524,0,0,1-.036.319A11.664,11.664,0,0,1,3.411,19.8L1.023,22.174C.458,22.736,0,22.539,0,21.756V15.2a.722.722,0,0,1,.715-.71H7.291Z",
    transform: "translate(0 -0.193)",
    fill: "#414042",
    fillRule: "evenodd"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRcIcon);
export default __webpack_public_path__ + "static/media/RcIcon.68968850de66af9cb8a09bc237db9967.svg";
export { ForwardRef as ReactComponent };